<template>
  <div class="login">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header bg-primary text-white">
            <h4 class="mb-0">{{ $t('login.title') }}</h4>
          </div>
          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            
            <form @submit.prevent="handleLogin">
              <div class="mb-3">
                <label for="email" class="form-label">{{ $t('login.email') }}</label>
                <input 
                  type="email" 
                  class="form-control" 
                  id="email" 
                  v-model="email" 
                  required
                >
              </div>
              
              <div class="mb-3">
                <label for="password" class="form-label">{{ $t('login.password') }}</label>
                <div class="d-flex justify-content-end mb-1">
                   <a href="#" class="small text-decoration-none" @click.prevent="showForgotModal = true">{{ $t('login.forgot_password') }}</a>
                </div>
                <input 
                  type="password" 
                  class="form-control" 
                  id="password" 
                  v-model="password" 
                  required
                >
              </div>
              
              <div class="d-grid">
                <button 
                  type="submit" 
                  class="btn btn-primary" 
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                  {{ $t('login.submit') }}
                </button>
              </div>
            </form>
            
            <div class="mt-3 text-center">
              <p v-html="$t('login.register_link')"></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Forgot Password Modal -->
    <div v-if="showForgotModal" class="modal-backdrop fade show"></div>
    <div v-if="showForgotModal" class="modal fade show d-block" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('login.reset_modal.title') }}</h5>
            <button type="button" class="btn-close" @click="showForgotModal = false"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t('login.reset_modal.instruction') }}</p>
            <div v-if="forgotMessage" class="alert alert-success">{{ forgotMessage }}</div>
            <div v-if="forgotError" class="alert alert-danger">{{ forgotError }}</div>
            
            <div class="mb-3">
               <input 
                 v-model="forgotEmail" 
                 type="email" 
                 class="form-control" 
                 :placeholder="$t('login.reset_modal.placeholder')"
               >
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="showForgotModal = false">{{ $t('login.reset_modal.close') }}</button>
            <button 
                type="button" 
                class="btn btn-primary" 
                @click="sendResetLink"
                :disabled="sendingLink || !forgotEmail"
            >
                {{ sendingLink ? $t('login.reset_modal.sending') : $t('login.reset_modal.send') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import axios from '@/axios'

export default {
  name: 'Login',
  data() {
    return {
      email: '',
      password: '',
      error: null,
      loading: false,
      
      // Forgot Password State
      showForgotModal: false,
      forgotEmail: '',
      forgotMessage: '',
      forgotError: '',
      sendingLink: false
    }
  },
  methods: {
    ...mapActions('auth', ['login']),
    
    async handleLogin() {
      this.loading = true
      this.error = null
      
      try {
        const result = await this.login({
          email: this.email,
          password: this.password
        })
        
        if (result.success) {
          // Redirect to dashboard or the page they were trying to access
          const redirectPath = this.$route.query.redirect || '/invoice'
          this.$router.push(redirectPath)
        } else {
          this.error = result.error
        }
      } catch (error) {
        this.error = 'An unexpected error occurred. Please try again.'
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async sendResetLink() {
        this.sendingLink = true;
        this.forgotMessage = '';
        this.forgotError = '';
        
        try {
            await axios.post('/api/auth/forgot-password', { email: this.forgotEmail });
            this.forgotMessage = "Reset link sent! Please check your email.";
            this.forgotEmail = '';
        } catch (err) {
            this.forgotError = err.response?.data?.error || "Failed to send reset link.";
        } finally {
            this.sendingLink = false;
        }
    }
  },
  mounted() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email
    }
  }
}
</script>